<template>
    <div class="slide" :style="'background-image: url(' + imageUrl + ')'">
        <div class="slide-content">
            <div class="slide-title">
                <slot></slot>
            </div>
            <a :href="url" class="btn btn-primary" @click="$emit('action')">{{ cta }}</a>
        </div>
    </div>
</template>

<script>
export default {
    name: "HeroSlide",
    props: {
        image: {
            required: true
        },
        cta: {
            type: String,
            default: 'Read more'
        },
        url: {
            type: String,
            default: '#'
        }
    },
    computed: {
        imageUrl() {
            return this.image !== null
                ? ('/storage/components/home-hero-slider/'+ this.image)
                : ('/storage/components/home-hero-slider/default/bg.jpg');
        }
    }
}
</script>

<style scoped>

</style>
